import { render, staticRenderFns } from "./invite_global.vue?vue&type=template&id=85fb9cf2&scoped=true"
import script from "./invite_global.vue?vue&type=script&lang=js"
export * from "./invite_global.vue?vue&type=script&lang=js"
import style0 from "./invite_global.vue?vue&type=style&index=0&id=85fb9cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb9cf2",
  null
  
)

export default component.exports